import React, { useState } from "react";
import { Typography } from "@mui/material";
import TaskView from "../common/TaskView";
import { AcousticTask, AcousticTaskDefinition } from "../common/models";
import { randomUUID } from "../../../utils";
import { TaskDemonstration } from "../common/TaskDemonstration";
import { AudioTaskDemonstration } from "../common/AudioTaskDemonstration";
import { translateReactNode } from "../../../../utils/translateReactNode";
import { useTranslation } from "react-i18next";

const TUTORIAL_URLS: Record<string, string> = {
  'en': 'assets/videos/tutorials/Prolonged_Vowel.mp4',
  'es-419': 'assets/videos/tutorials/Prolonged_Vowel-es-419.mp4'
}

const Definition: AcousticTaskDefinition = {
  name: "Prolonged vowel",
  title: "Prolonged vowel",
  description: "This task helps us analyze features in your voice.",
  cohort: 'generic',
  type: 'acoustic-task',
  estimatedCompletionTime: '0:50',
  subTaskDefinitions: [{
    name: "Prolonged vowel",
    title: "",
    instructions:<>
      <Typography variant='h5' component='div'>
        Please press the play button to listen to the demonstration on how to complete the task. Then, tap the record button and imitate the speaker by repeating the sentence “1, 2, 3 aah” in your normal voice. Please hold the sound “aah” until the timer runs out.
      </Typography>
      <TaskDemonstration>
        <Typography variant="h6" component="div">Task Demonstration</Typography>
        <AudioTaskDemonstration audioSrc="assets/audio/ProlongedVowelAudio.mp3" />
      </TaskDemonstration>
    </>,
    profileName: 'speech',
    stopwatchSeconds: 12
  }]
};
export const ProlongedVowelDefinition = Definition;

//* TODO: Animation for the timer
export const ProlongedVowel =  ({onCompletion}: {onCompletion: () => void}) => {
  const { i18n } = useTranslation();
  const [task, _setTask] = useState<AcousticTask>(() => ({
    ...Definition,
    id: randomUUID(),
    startedAt: new Date().toISOString(),
    completedAt: null,
    status: 'pending',
    subTasks: Definition.subTaskDefinitions.map((definition) => ({
      ...definition,
      id: randomUUID(),
      instructions: translateReactNode(definition.instructions, Definition.cohort),
      title: translateReactNode(definition.title, Definition.cohort) as string
    })),
    tutorialUrl: TUTORIAL_URLS[i18n.language] || TUTORIAL_URLS['en']
  }));


  const handleOnCompletion = () => {
    console.log("Audio task completed", task.title);
    onCompletion();
  }

  return (
    <div>
      <TaskView
        task={task}
        onCompletion={handleOnCompletion}
      />
    </div>
  );
}

